/**
 * 「納品書・金額が記載された明細書を同封しない」チェックボックスの保存処理。
 *
 * このチェックボックスはカートページ（sections/kikuyo-main-cart.liquid）と
 * カートドロワー（sections/cart-drawer.liquid）の両方にあり、ドロワーは
 * AJAX で中身が差し替わるため（theme.js の CartDrawer は DOMParser +
 * replaceChildren で再描画する）、document へのイベント委譲で change を拾う。
 *
 * チェック状態は cart attribute として保存され、注文の「追加情報」に表示される。
 * form 送信時にも同じ値が送られるため（snippet 側の hidden input / checkbox）、
 * 保存に失敗しても結算時に属性が欠けない。
 */
(() => {
  const ATTRIBUTE_NAME_PATTERN = /^attributes\[(.+)\]$/;

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest?.('[data-kikuyo-packing-slip]');

    if (!toggle) return;

    const match = ATTRIBUTE_NAME_PATTERN.exec(toggle.name);

    if (!match) return;

    const attributeName = match[1];
    const checked = toggle.checked;
    const root = window.Shopify?.routes?.root ?? '/';

    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // チェックを外したときは空値を送り、属性をリセットする。
      body: JSON.stringify({ attributes: { [attributeName]: checked ? toggle.value : '' } })
    })
      .then((response) => {
        if (!response.ok) return;
        // 同じ属性を使うもう一方のチェックボックス（カートページ / ドロワー）の表示を揃える。
        if (toggle.checked !== checked) return;

        document.querySelectorAll('[data-kikuyo-packing-slip]').forEach((other) => {
          if (other !== toggle && other.name === toggle.name) {
            other.checked = checked;
          }
        });
      })
      .catch(() => {
        // 保存に失敗しても form 送信時に値が送られるため、ここでは何もしない。
      });
  });
})();
